// Import the functions you need from the SDKs you need
import { initializeApp, getApps } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDQ6EOVpS8Y-4CrG0FgdGnsOdNsfkD8_Ew",
  authDomain: "boekingsplatform.firebaseapp.com",
  projectId: "boekingsplatform",
  storageBucket: "boekingsplatform.appspot.com",
  messagingSenderId: "200575295744",
  appId: "1:200575295744:web:24db86b02175755915d3e5",
};

let firebaseApp;

export const initializeFirebase = () => {
  // Check if Firebase is already initialized
  if (!getApps().length) {
    firebaseApp = initializeApp(firebaseConfig);
  } else {
    firebaseApp = getApps()[0];
  }
  return firebaseApp;
};
export const onMessageListener = () =>
  new Promise((resolve) => {
    const app = initializeFirebase();
    const messaging = getMessaging(app);
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
});

export const requestForToken = () => {
  const app = initializeFirebase();
  const messaging = getMessaging(app);
  return getToken(messaging, { vapidKey: "BGqLMaiQHld-ccYQgftDL16MykZrlyvBczAUNJBPhfVMEcg5pXp8Dwdw-j9eA0-vqJ1sKdfyWhHzOJj2l7qTh24" })
    .then((currentToken) => {
      if (currentToken) {
        return currentToken;
      } else {
        // Show permission request UI
        alert("No registration token available. Request permission to generate one.");
      }
    })
    .catch((err) => {
      console.error("Push notification token error:", err.message);
    });
};
